import Children from '../../../layouts/Children';

const routes = [
  {
    path: 'booking-resources',
    component: Children,

    children: [
      {
        path: '',
        component: Children,

        children: [
          {
            path: '',
            name: 'booking-resources',
            component: () => import('../pages/BookingResourcesPage.vue')
          },
          {
            path: 'create',
            name: 'booking-resources.create',
            component: () => import('../pages/BookingResourceCreatePage.vue')
          },
          {
            path: ':id',
            name: 'booking-resources.show',
            component: () => import('../pages/BookingResourceShowPage.vue'),
            props: route => ({
              id: Number(route.params.id)
            })
          },
          {
            path: ':id/edit',
            name: 'booking-resources.edit',
            component: () => import('../pages/BookingResourceEditPage.vue'),
            props: route => ({
              id: Number(route.params.id)
            })
          }
        ]
      }
    ]
  }
];

export default routes;
